import * as Yup from "yup";
import REGEXS from "../utils/regex";

export const chemoProtocolSchema = Yup.object().shape({
    // chemo_regimen_details: Yup.string()
    //     .required("Chemotherapy regimen details are required"),

    // treatment_intent: Yup.string()
    //     .required("Treatment intent is required"),

    // vascular_access: Yup.string()
    //     .required("Vascular access is required"),

    // known_drug_allergies: Yup.string()
    //     .required("Known drug allergies is required"),

    // significant_adverse_reactions_reported: Yup.string()
    //     .required("Significant adverse reactions is required"),


    chemo_dosage: Yup.array()
        .of(
            Yup.object().shape({
                chemo_administered_date: Yup.date()
                    .nullable()
                    .transform((value, originalValue) =>
                        originalValue ? value : null
                    )
                    .test(
                        "not-future-date",
                        "Date cannot be in the future",
                        (value) => !value || value <= new Date()
                    ),

                chemo_dosage: Yup.string()
                    .nullable()
                    .matches(REGEXS.number, "Only numbers are allowed")
                    .test(
                        "max-10",
                        "Value cannot be greater than 99",
                        (value) => {
                            if (!value) return true;
                            return Number(value) <= 99;
                        }
                    ),
            })
        )
        .test(
            "unique-chemo-dates",
            "Two entries cannot have the same date",
            (rows) => {
                if (!rows || rows.length === 0) return true;

                const dates = rows
                    .map((row) => row?.chemo_administered_date)
                    .filter(Boolean); // remove nulls

                const uniqueDates = new Set(dates);

                return dates.length === uniqueDates.size;
            }
        ),

});
